<template>
  <div class="main-content">
    <!-- 列表页 -->
    <div>
      <el-form :inline="true" :model="searchForm" class="form-content">
        <el-row :gutter="20" class="slt">
          <el-form-item label="操作者">
            <el-input v-model="searchForm.account" placeholder="操作者" clearable></el-input>
          </el-form-item>
          <el-form-item label="类型">
            <el-select v-model="searchForm.type" placeholder="操作类型" clearable>
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label"
                         :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间区间">
            <el-date-picker
                v-model="searchForm.dateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                clearable
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search()">查询</el-button>
            <el-button @click="resetFilter">重置</el-button>
          </el-form-item>
        </el-row>
      </el-form>
      <div class="table-content">
        <el-table
            :data="dataList" border
            v-loading="dataListLoading"
            style="width: 100%">
          <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
          <el-table-column prop="account" label="操作人员" width="200"></el-table-column>
          <el-table-column prop="userType" label="操作者身份" width="150">
            <template slot-scope="scope">
              <el-tag type="info" effect="plain">
                {{ scope.row.userType == '0' ? '超级管理员' : '一般管理员' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="操作类型" width="152">
            <template slot-scope="scope">
              <el-tag type="info" effect="plain">
                {{ getSubjectLabel(scope.row.type) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="subType" label="操作" width="150"></el-table-column>
          <el-table-column prop="action" label="具体信息" min-width="150"></el-table-column>
          <el-table-column prop="createTime" label="操作时间" width="200">
            <template slot-scope="scope">
              {{ formatDateTime(scope.row.createTime) }}
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <div class="block">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              background
              :current-page="currentPage"
              :page-sizes="[8,16,24,32]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

const TypeEnum = {
  ABOUT_US_TYPE: '关于我们',
  NEWS_TYPE: '新闻资讯',
  MESSAGE_TYPE: '联系我们',
  FAQ_TYPE: 'FAQ',
  PARTNER_TYPE: '合作伙伴',
  ADMIN_LOGIN_TYPE: '登录',
  ADMIN_TYPE: '管理员',
};
export default {
  data() {
    return {
      searchForm: {
        account: '',
        type: '',
        dateRange: [],
      },
      currentPage: 1,
      pageSize: 8,
      dataList: [],
      total: 0,
      dataListLoading: false,
      statusOptions: Object.entries(TypeEnum).map(([value, label]) => ({ value, label })),
    }
  },
  created() {
    this.getDataList();
  },
  methods: {
    getSubjectLabel(value) {
      return TypeEnum[value] || value;
    },
    resetFilter() {
      this.searchForm.account = '';
      this.searchForm.type = '';
      this.searchForm.dateRange = [];
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getDataList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getDataList();
    },
    search() {
      this.currentPage = 1;
      this.getDataList();
    },
    getDataList() {
      this.dataListLoading = true;
      let startTime = '';
      let endTime = '';
      if (this.searchForm.dateRange[0]) {
        const startDate = new Date(this.searchForm.dateRange[0]);
        startTime = this.formatted(startDate)+` 00:00:00`
      }
      if (this.searchForm.dateRange[1]) {
        const endDate = new Date(this.searchForm.dateRange[1]);
        endTime = this.formatted(endDate)+` 23:59:59`;
      }
      this.$api.getLogRecord({
        page: this.currentPage,
        nums: this.pageSize,
        account: this.searchForm.account,
        ...(this.searchForm.type ? { type: this.searchForm.type } : {}),
        ...(startTime ? { startTime } : {}),
        ...(endTime ? { endTime } : {}),
      }).then(res => {
        if (res.code == 200) {
          this.dataList = res.data.list;
          this.total = res.data.total;
        }
      });
      this.dataListLoading = false;
    },
    formatted(endDate){
      return `${endDate.getFullYear()}-${String(endDate.getMonth() + 1).padStart(2, '0')}-${String(endDate.getDate()).padStart(2, '0')}`;
    },
    formatDateTime(timestamp) {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
  }
}
</script>

<style scoped>
.slt, .ad {
  margin: 0;
  display: flex;
}

.block {
  display: flex;
  justify-content: center;
  padding-top: 15px;
  padding-bottom: 10px;
  width: 100%;
}
</style>